import { createFileRoute } from "@tanstack/react-router";

import Registration from "./-components/Registration";
import WithGoogleAuth from "@/components/WithGoogleAuth";
import { GoogleAuthProvider } from "@/providers/GoogleAuthProvider";

export const Route = createFileRoute("/_app/register")({
  component: Register,
});

/** Not a child of `_dashboard`: sign-up has no dashboard chrome. */
function Register() {
  return (
    <WithGoogleAuth>
      <GoogleAuthProvider endpoint="register" flow="redirect">
        <Registration />
      </GoogleAuthProvider>
    </WithGoogleAuth>
  );
}
